var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vbg-ff-root-container"},[_c('vpsHeader'),_c('div',{staticClass:"vbg-ff-content-container"},[_c('router-view')],1),_c('vpsFooter',{staticClass:"footer-margin-top"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }